import {ChangeDetectionStrategy, Component, OnInit, Output, EventEmitter} from '@angular/core';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';

import {TerraUtils} from 'src/app/shared/TerraUtils';
import {RoutingService} from 'src/app/services/routing.service';
import TermType from 'src/app/shared/enums/TermsTypes.enum';
import AccountType from 'src/app/shared/enums/AccountType.enum';
import {UnitCreateBankAccountService} from '../unit-create-bank-account.service';
import {UnitBankAccountReqRes} from '../../../../models/gp/UnitBankAccountReqRes.model';
import {BaseResponseDto} from '../../../../models/BaseResponseDto.model';
import {UtilsService} from '../../../../../services/utils.service';
import {UnitApplicationParentType} from 'src/app/shared/enums/unit-bank-account/UnitApplicationParentType.enum';
import {map, switchMap} from 'rxjs/operators';
import {UserService} from 'src/app/services/shared/user.service';
import UnitAccountProvider from 'src/app/shared/enums/UnitAccountProvider.enum';

@Component({
  selector: 'terra-unit-create-bank-account-review-step',
  templateUrl: './unit-create-bank-account-review-step.component.html',
  styleUrls: [
    './unit-create-bank-account-review-step.component.scss',
    '../unit-create-bank-account.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitCreateBankAccountReviewStepComponent implements OnInit {

  @Output() bankAccountAdded: EventEmitter<{ reason: string, payload: UnitBankAccountReqRes }> = new EventEmitter<{ reason: string, payload: UnitBankAccountReqRes }>();
  // consts:
  generalServerErrorMessage: string = TerraUtils.consts.messages.GENERAL_SUBMIT_ERROR;
  UnitAccountType = AccountType;
  termType = TermType;
  unitApplicationParentType = UnitApplicationParentType;

  processingSubmit$ = new BehaviorSubject(false);
  isSubmitAttempt$ = new BehaviorSubject(false);

  account$ = this.unitCreateBankAccountService.bankAccountFormDetails$;

  originUrl$ = this.account$.pipe(
    switchMap(account => this.unitCreateBankAccountService.originUrl(account.preselectedType))
  );

  isGpSide$ = this.account$.pipe(
    map(account => account.preselectedType !== UnitApplicationParentType.LP)
  );

  unitAccountThreadProvider$ = this.userService.accountDetails$.pipe(
    // if no organization -> then also use thread
    map(acc => !!!acc.organizationDetails?.unitAccountProvider || (acc.organizationDetails?.unitAccountProvider === UnitAccountProvider.Thread))
  );

  fees$ = this.unitCreateBankAccountService.fees$;

  pageForm = this.fb.group({
    termsOfServiceAgreement: [false, Validators.requiredTrue]
  });

  constructor(
    private unitCreateBankAccountService: UnitCreateBankAccountService,
    private router: Router,
    private routingService: RoutingService,
    private fb: UntypedFormBuilder,
    private utilsService: UtilsService,
    private userService: UserService
  ) {
  }

  ngOnInit(): void {
  }

  get lpExternalAccount() {
    return this.routingService.lpCreateBankAccount;
  }

  backToFirstStep() {
    this.resetStep();
    this.unitCreateBankAccountService.backToFirstStep();
  }

  submit() {
    this.isSubmitAttempt$.next(true);

    if (!this.pageForm.valid) {
      return;
    }

    this.processingSubmit$.next(true);

    this.unitCreateBankAccountService.createBankAccount()
      .subscribe(
        response => {
          // this.router.navigateByUrl(this.routingService.creBankAccountPage(response.id));
          this.bankAccountAdded.next({reason: 'new', payload: response});
          this.processingSubmit$.next(false);
        },
        error => {
          if (error instanceof BaseResponseDto) {
            this.utilsService.alertErrorMessage(error);
          }
          this.processingSubmit$.next(false);
        }
      );
  }

  private resetStep() {
    this.isSubmitAttempt$.next(false);
  }
}
